module.exports = "<h3>{{article.title}}</h3>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LbSubtitle.vue
 ** module id = 144
 ** module chunks = 0
 **/